import ExtendedIdentityVerificationInitial from '@perpay-web/fintech/components/screens/IdentityVerificationRequired/IdentityVerificationExtended';

const CardApplicationExtendedIdentityVerificationContainer = () => (
    <ExtendedIdentityVerificationInitial />
);

export default CardApplicationExtendedIdentityVerificationContainer;
